import { makeStyles, createStyles } from 'styles/utils';

export const useStyles = makeStyles(theme => createStyles({
  root: {
    padding:theme.spacing(0, 2.5, 0, 1.5),
    fontSize: 12,
  },
  icon: {
    marginRight: 8,
    display: 'inline-block',
    width: 11,
    height: 11,
    borderRadius: '50%',
    verticalAlign: 'middle',
  },
  label: {
    fontSize: 12,
  },
  totalLabel: {
    fontSize: 12,
    fontWeight: 500,
  },
  totalValue: {
    fontSize: 12,
  },
  valueContainer: {
    marginLeft: 30,
    display: 'inline-flex',
    alignSelf: 'flex-start',
    alignItems: 'center',
  },
  value: {
    fontSize: 12,
    fontWeight: 500,
  },
  valueFraction: {
    marginLeft: 4,
    minWidth: 28,
    fontSize: 11,
  },
}));
